/***
 * 姓名 :D
 * 创建时间:2019-3-8
 * 描述：销毁组件
 * 更新记录: 
 */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SwDestructionService {

  constructor() { }

  //销毁组件方法,传递组件名
  destruction(cname: string) {
    //根据组建名找到组件集合
    var node = document.getElementsByTagName(cname);
    //遍历删除所有组件
    for (var i = 0; i < node.length; i++) {
      //删除元素
      if (node[i]) {
        node[i].parentNode.removeChild(node[i]);
      }
    }
  }

}
